// extracted by mini-css-extract-plugin
module.exports =  {"canvas":"qrmZOq","hidden":"aKABO_","visuallyHidden":"HTEhz9"};